import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import toast from "react-hot-toast";
import SiteInchargeDetails from "../Contractor/SiteInchargeDetails";
import SuperVisorDetails from "../Contractor/SuperVisorDetails";
import { V_URL } from "../../BaseUrl";

const ContractorModal = ({ show, onClose, onContractorCreated }) => {
  const [contractor, setContractor] = useState({
    name: "",
    phone: "",
    email: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setContractor({ ...contractor, [e.target.name]: e.target.value });
  };

  const [site, setSite] = useState({ name: "", mobile: "", email: "" });
  const [siteData, setSiteData] = useState([]);
  const [errors2, setErrors2] = useState({});
  const [editIndex, setEditIndex] = useState(null);

  const [superVisor, setSuperVisor] = useState({
    name: "",
    mobile: "",
    email: "",
  });
  const [superVisorData, setSuperVisorData] = useState([]);
  const [errors3, setErrors3] = useState({});
  const [editIndex2, setEditIndex2] = useState(null);

  const [disable, setDisable] = useState(false);

  const validation = () => {
    let isValid = true;
    let err = {};

    if (!contractor.name?.trim()) {
      err.name_err = "Please enter name";
      isValid = false;
    }

    const phoneDigits = contractor.phone?.replace(/\D/g, "");
    if (phoneDigits?.length !== 10) {
      err.phone_err = "Enter valid 10-digit mobile";
      isValid = false;
    }

    if (!contractor.email?.includes("@")) {
      err.email_err = "Enter valid email";
      isValid = false;
    }

    // if (!siteData.length) {
    //   err.site_err = "Add at least 1 site incharge";
    //   isValid = false;
    // }

    // if (!superVisorData.length) {
    //   err.superVisor_err = "Add at least 1 supervisor";
    //   isValid = false;
    // }

    setErrors(err);
    return isValid;
  };

  const handleSubmit = async () => {
    if (!validation()) return;

    setDisable(true);

    const formData = new URLSearchParams();
    formData.append("name", contractor.name);
    formData.append("mobile", contractor.phone);
    formData.append("email", contractor.email);
    formData.append("site_incharge", JSON.stringify(siteData));
    formData.append("site_supervisor", JSON.stringify(superVisorData));

    try {
      const res = await axios({
        method: "post",
        url: `${V_URL}/admin/manage-contractor`,
        data: formData,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: "Bearer " + localStorage.getItem("VA_TOKEN"),
        },
      });

      if (res?.data?.success) {
        console.log("Contractor API response:", res.data);
        toast.success(res?.data?.message|| "Contractor created successfully!");
        onContractorCreated(res?.data?.data);
        handleReset();
        onClose();
      } else {
        toast.error(res?.data?.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Something went wrong");
    }

    setDisable(false);
  };

  const handleReset = () => {
    setContractor({ name: "", phone: "", email: "" });
    setSiteData([]);
    setSuperVisorData([]);
    setErrors({});
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      size="lg"
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Add Contractor</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="row mb-3">
          <div className="col-12 col-md-4">
            <label>Contractor Name *</label>
            <input
              className="form-control"
              name="name"
              value={contractor.name}
              onChange={handleChange}
            />
            <div className="error text-danger">{errors.name_err}</div>
          </div>

          <div className="col-12 col-md-4">
            <label>Mobile *</label>
            <input
              className="form-control"
              name="phone"
              value={contractor.phone}
              onChange={handleChange}
            />
            <div className="error text-danger">{errors.phone_err}</div>
          </div>

          <div className="col-12 col-md-4">
            <label>Email *</label>
            <input
              className="form-control"
              name="email"
              value={contractor.email}
              onChange={handleChange}
            />
            <div className="error text-danger">{errors.email_err}</div>
          </div>
        </div>

        <SiteInchargeDetails
          site={site}
          siteData={siteData}
          errors2={errors2}
          siteError={errors.site_err}
          editIndex={editIndex}
          handleChangeSite={(e) =>
            setSite({ ...site, [e.target.name]: e.target.value })
          }
          handleSaveSite={() => {
            let newErrors = {};
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const mobileRegex = /^[0-9]{10}$/;

            if (!site.name?.trim()) newErrors.name_err = "Please enter name";
            if (!mobileRegex.test(site.mobile))
              newErrors.mobile_err = "Enter valid mobile";
            if (!emailRegex.test(site.email))
              newErrors.email_err = "Enter valid email";

            if (Object.keys(newErrors).length) {
              setErrors2(newErrors);
            } else {
              if (editIndex !== null) {
                const updated = siteData.map((x, i) =>
                  i === editIndex ? site : x
                );
                setSiteData(updated);
                setEditIndex(null);
              } else {
                setSiteData([...siteData, site]);
              }
              setSite({ name: "", mobile: "", email: "" });
              setErrors2({});
            }
          }}
          handleEdit={(i) => {
            setEditIndex(i);
            setSite(siteData[i]);
          }}
          handleDelete={(i) => {
            setSiteData(siteData.filter((_, idx) => idx !== i));
          }}
        />

        <SuperVisorDetails
          superVisor={superVisor}
          superVisorData={superVisorData}
          errors3={errors3}
          superVisorError={errors.superVisor_err}
          editIndex2={editIndex2}
          handleChangeSupervisor={(e) =>
            setSuperVisor({ ...superVisor, [e.target.name]: e.target.value })
          }
          handleSaveSuperVisor={() => {
            let newErrors = {};
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const mobileRegex = /^[0-9]{10}$/;

            if (!superVisor.name?.trim())
              newErrors.name_err = "Please enter name";
            if (!mobileRegex.test(superVisor.mobile))
              newErrors.mobile_err = "Enter valid mobile";
            if (!emailRegex.test(superVisor.email))
              newErrors.email_err = "Enter valid email";

            if (Object.keys(newErrors).length) {
              setErrors3(newErrors);
            } else {
              if (editIndex2 !== null) {
                const updated = superVisorData.map((x, i) =>
                  i === editIndex2 ? superVisor : x
                );
                setSuperVisorData(updated);
                setEditIndex2(null);
              } else {
                setSuperVisorData([...superVisorData, superVisor]);
              }
              setSuperVisor({ name: "", mobile: "", email: "" });
              setErrors3({});
            }
          }}
          handleEditSupervisor={(i) => {
            setEditIndex2(i);
            setSuperVisor(superVisorData[i]);
          }}
          handleDeleteSupervisor={(i) => {
            setSuperVisorData(superVisorData.filter((_, idx) => idx !== i));
          }}
        />
      </Modal.Body>

      <Modal.Footer>
        <button className="btn btn-secondary" onClick={onClose}>
          Cancel
        </button>

        <button
          className="btn btn-primary"
          onClick={handleSubmit}
          disabled={disable}
        >
          {disable ? "Saving..." : "Save Contractor"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ContractorModal;
